import { approvedGrokItems } from "./protocol";
import type { QaAction, QaItem, QaSession, QaTask } from "./types";

function defaultActions(item: QaItem, targetUrl: string): QaAction[] {
  if (item.actions.length) {
    return item.actions.map((a) =>
      a.type === "goto" && !a.url ? { ...a, url: targetUrl } : a,
    );
  }
  return [
    { type: "goto", url: targetUrl },
    { type: "expectText", text: item.title },
  ];
}

/** Turn owner-approved, Grok-authored boxes into run tasks. Nothing else. */
export function generateRunTasks(session: QaSession): QaSession {
  const boxes = approvedGrokItems(session.items);
  const tasks: QaTask[] = boxes.map((item) => ({
    itemId: item.id,
    title: item.title,
    actions: defaultActions(item, session.targetUrl.trim()),
  }));
  const taskIds = new Set(tasks.map((t) => t.itemId));
  return {
    ...session,
    tasks,
    generatedAt: new Date().toISOString(),
    items: session.items.map((item) =>
      taskIds.has(item.id) && item.status !== "pass"
        ? { ...item, status: "generated" as const, retries: 0 }
        : item,
    ),
  };
}
